import axiosInstance from '@api/axios-instance.ts';
import superAdminAxios from '@api/super-admin-axios-instance.ts';

export const signIn = async (body: { email: string; password: string }) => {
  const response = await axiosInstance.post('/auth/login', body);
  return response.data;
};

export const signInRefreshToken = async (refreshToken: string) => {
  const response = await axiosInstance.post('/auth/refresh', {
    refreshToken
  });
  return response.data;
};

export const verifyBeforePasswordChange = async (body: {
  password: string;
}) => {
  const response = await axiosInstance.post('/pms/users/verifyPassword', body);
  return response.data;
};

export const changePassword = async (body: { password: string }) => {
  const response = await axiosInstance.post('/pms/users/editPassword', body);
  return response.data;
};

export const getUsersToken = async (id?: any): Promise<any> => {
  const response = await superAdminAxios.get(`/pms/users/adminToken/${id}`);

  return response.data;
};

export const getUsersBranding = async (domain?: any): Promise<any> => {
  const response = await axiosInstance.get(`/pms/users/platformConfig/${domain}`);
  return response.data;
};
